import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';

import { FaCheck } from 'react-icons/fa';



const Plan = ({ plan }) => {

  const { icon, title, content, price, features } = plan; // Extracting data from plan

  return (
    <div className="price-item">

      <div className='top'>
        <div className='top-icon'>{icon}</div> {/* Dynamic Icon */}
        <h3>{title}</h3> {/* Plan Title */}
        <p>{content}</p> {/* Plan  */}
      </div>

        {/* List of Features */}
        <ul>
          {features.map((feature, index) => (
            <li key={index}><div className='icon'><FaCheck /></div> {feature}</li> 
          ))}
        </ul>

        <div className='bottom'>
          <div className="price">${price}</div> {/* Plan Price */}
          <Button link={"Tour-Booking"} title={"Book Now"} />
        </div>

       


    </div>
  );
};

export default Plan;